<template lang="pug">
  .column.is-one-half-mobile.is-one-half-tablet.is-one-quarter-desktop.is-one-quarter-widescreen.is-one-quarter-fullhd
    .card
      header.card-header
        p.card-header-title
          small {{ llenadera.id}}
      .card-content
        .columns.is-mobile
          .column.is-4
            span.card-content-llen-tit
              b {{ llenadera.pg }}
          .column.is-8
            span.tag(:class="llenadera.estado == 1 ? 'is-danger' : 'is-black'")
              span.icon(v-show="llenadera.estado == 1")
                .fas.fa-charging-station
              span.icon(v-show="llenadera.estado == 0")
                .fas.fa-gas-pump
              | {{ llenadera.estado == 1 ? 'Operando' : 'Libre' }}
        .columns.is-mobile
          progress-bar(
            :variant="'danger'"
            :size="'is-small'"
            :value="progressValue"
            :max="100"
            :label="false"
            v-if="llenadera.estado== 1"
          )
          progress-bar(
            :variant="'info'"
            :size="'is-small'"
            :value="progressValue"
            :max="100"
            :label="false"
            v-else
          )
          | &nbsp
          span.porcentaje.is-size-7 {{llenadera.porcentaje}}%
        .columns.is-mobile
          img(src='../../../assets/autotanqueH3Disabled.png' alt='' v-if="llenadera.estado==='0'")
          img(src='../../../assets/autotanqueH3.png' alt='' v-else)
        .columns.is-mobile
          div.has-text-dark
            p.card-content-llen-tit
              | Prog.&nbsp
              span.card-content-llen
                | {{ llenadera.programado}}&nbsp
              small l.
            p.card-content-llen-tit
              | Act.&nbsp
              span.card-content-llen
                | {{ llenadera.parcial}}&nbsp
              small l.
            p.card-content-llen-tit
              | Flujo.&nbsp
              span.card-content-llen
                | {{ llenadera.flujo}}&nbsp
              small Ton/hr.
</template>


<script>
  import ProgressBar from "vue-bulma-progress-component"
  import switch_llenaderas from '@/components/estaciones_Componentes/layouts/switch_llenaderas.vue'

  export default {
    name: 'card_Llenadera',
    components: { ProgressBar, switch_llenaderas },
    props: {
      llenadera: {
        type: Object,
        default: () => {}
      },
    },
    data() {
      return {
        progressValue: 0
      }
    },
    watch: {
      llenadera() {
        this.progressValue = parseFloat(this.llenadera.porcentaje, 2)
      }
    },
    methods: {
      iniciarComponente() {
        
      },
      /* convetirNombre (pg) {
        let inicial = ''
        let final = ''
        let pgStr = ''
        let NombrePGstr = ''

          switch (pg.length) {
            case 4:
              pgStr = pg
              break;
            case 3:
              pgStr = `0${pg}`
              break;
            case 2:
              pgStr = `00${pg}`
              break;
            case 1:
            pgStr = `000${pg}`
              break;
          }
          inicial = pgStr.substring(0,1);
          final = pgStr.substring(1,4);

            switch (inicial) {
              case '8':
                NombrePGstr = `RP-0${final}`;
                break;
              case '9':
                NombrePGstr = `FZS-0${final}`;
                break;
              case '5':
                NombrePGstr = `PQ-0${final}`;
                break;
              default:
                NombrePGstr = `PG-${inicial}${final}`;
            }
            return NombrePGstr
      }, */
    },
    created () {
      this.iniciarComponente()
    },
  }
</script>

<style lang="css" scoped>
  .card-content-llen{
  font-weight: 600;
  color: #057d8d;
  }

  .card-content-llen-tit {
    font-weight: 600;
    color: #54545c !important;
    font-size: 14px;
  }

  .card-header-title {
    margin-bottom: 0;
    font-size: 20px;
    color: #54545c;
    font-weight: 600;
    padding: 0.5rem;
  }

  .card-header {
    box-shadow: none;
  }

  .progress-bar {
	 align-items: center;
	 margin-bottom: 1.25rem;
  }
  .progress-bar .progress {
    position: relative;
    margin-bottom: 0 !important;
  }
  .progress-bar .progress + span {
    min-width: 3.25rem;
    text-align: right;
    margin-left: 0.625rem;
    margin-top: -5px;
  }
</style>


// WEBPACK FOOTER //
// src/components/estaciones_Componentes/layouts/card_Llenadera.vue